// planned vs actual quantities and costs per position; actual from reports (each report counted once) or the linked map object, or set by hand
import { uid, pathLength, pipeLatLngs } from './model';

export const newLine = (o = {}) => ({ id: uid('lin'), name: '', unit: 'm', plan: null, price: null, src: 'reports', man: null, ...o });
const num = (v) => (v === '' || v == null ? null : Number.isFinite(+String(v).replace(',', '.')) ? +String(v).replace(',', '.') : null);
export { num as qtyNum };

// reports of the position that count: no drafts, no addendum copies; Map by id so a report can never be summed twice
const counted = (p, pos) => [...new Map((p.reports || []).filter((r) => r.pm?.posId === pos.id && r.pm?.status !== 'draft' && !r.pm?.addendumOf).map((r) => [r.id, r])).values()];
function mapQty(p, pos, line) {
  if (!pos.obj) return null;
  if (pos.obj.kind === 'pipe') { const pipe = (p.pipes || []).find((x) => x.id === pos.obj.id); return pipe ? Math.round(pathLength(pipeLatLngs(pipe, p.fittings || [])) * 10) / 10 : null; }
  return (p.fittings || []).some((f) => f.id === pos.obj.id) ? 1 : null;
}
export function actual(p, pos, line) {
  if (line.man != null) return { v: line.man, how: 'manual' };
  if (line.src === 'map') return { v: mapQty(p, pos, line), how: 'map' };
  const reps = counted(p, pos), v = reps.reduce((a, r) => a + (num(r.pm?.qty?.[line.id]) || 0), 0);
  return { v: reps.some((r) => r.pm?.qty?.[line.id] != null) ? Math.round(v * 100) / 100 : null, how: 'reports', n: reps.filter((r) => r.pm?.qty?.[line.id] != null).length };
}
export function qtyRows(p) {
  const rows = [];
  for (const pos of p.pm?.positions || []) for (const line of pos.lines || []) {
    const a = actual(p, pos, line), pc = line.plan != null && line.price != null ? line.plan * line.price : null, ac = a.v != null && line.price != null ? a.v * line.price : null;
    rows.push({ pos, line, a, pc, ac, diff: a.v != null && line.plan != null ? a.v - line.plan : null });
  }
  return { rows, plan: rows.reduce((s, r) => s + (r.pc || 0), 0), ist: rows.reduce((s, r) => s + (r.ac || 0), 0) };
}
